<app-consultation-history-control readOnly="true" [patientId]="patientId" [medicalAppointmentId]="medicalAppointmentId"></app-consultation-history-control>